// extracted by mini-css-extract-plugin
export var button = "_fr-2";
export var card = "_fr-0";
export var closeButtonContainer = "_fr-3";
export var iconContainer = "_fr-1";